export default __webpack_public_path__ + "static/media/Icon=Task Type.dedf63a9.svg";